import { CommonModule } from "@angular/common";
import { NgModule, ModuleWithProviders } from "@angular/core";
import { AbpModule } from "../../node_modules/abp-ng2-module/dist/src/abp.module";
import { RouterModule } from "@angular/router";
import { NgxPaginationModule } from "ngx-pagination";
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";

import { DragDropModule } from "@angular/cdk/drag-drop";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { CdkTableModule } from "@angular/cdk/table";
import { CdkTreeModule } from "@angular/cdk/tree";
import { MatButtonModule, MatIconModule, MatPaginatorModule, MatTableModule } from "@angular/material";
import { AppSessionService } from "./session/app-session.service";
import { AppRouteGuard } from "./auth/auth-route-guard";
import { AppAuthService } from "./auth/app-auth.service";
import { SubheaderService } from "../app/core/_base/layout";
import { PanelReportFilterComponent } from "./components/panel-report-filter/panel-report-filter.component";
import { PanelReportBodyComponent } from "./components/panel-report-body/panel-report-body.component";
import { GenericGridComponent } from "./components/generic-grid/generic-grid.component";
import { GenericFormComponent } from "./components/generic-form/generic-form.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GMapsService } from "./services/gmap/gmaps.service";
import { GenericMapComponent } from "./components/generic-map/generic-map.component";
import { GenericMenuComponent } from "./components/generic-menu/generic-menu.component";
import { SystemAdminRoutingModule } from "@app/views/pages/platom/system-admin/system-admin-routing.module";
import { StickySideMenuComponent } from './components/sticky-side-menu/sticky-side-menu.component';
import { CoreModule } from "@app/core/core.module";

@NgModule({
	imports: [
		CommonModule,
		CoreModule,
		AbpModule,
		RouterModule,
		NgxPaginationModule,
		

		//04.11.2024
		MatTableModule,
		MatButtonModule,
		MatIconModule,
		MatPaginatorModule,

		//07.11.2024
		ReactiveFormsModule,
		FormsModule,
		NgbDropdownModule,
	],
	declarations: [PanelReportFilterComponent, PanelReportBodyComponent, GenericGridComponent, GenericFormComponent, GenericMapComponent, GenericMenuComponent, StickySideMenuComponent],
	exports: [
		//CdkTableModule,
		//CdkTreeModule,
		//DragDropModule,

		//ScrollingModule,
		PanelReportBodyComponent,
		PanelReportFilterComponent,
		GenericGridComponent,
		GenericFormComponent,
		GenericMapComponent,
		GenericMenuComponent,
		StickySideMenuComponent,
		// FormsModule,
		NgbDropdownModule,
	],
})
export class SharedModule {
	static forRoot(): ModuleWithProviders {
		return {
			ngModule: SharedModule,
			providers: [
				AppSessionService,
				//AppUrlService,
				AppAuthService,
				AppRouteGuard,
				SubheaderService,
				GMapsService,
			],
		};
	}
}
